import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';

export function useAvatars() {
  const getRecipientAvatars = (recipients: Recipient[]) =>
    recipients.map(recipient => ({
      name:
        recipient.fullName ||
        getFullName(recipient.firstName, recipient.lastName) ||
        recipient.email,
      thumbUrl: recipient.thumbUrl,
    }));

  const getFullName = (firstName: string, lastName: string) =>
    `${firstName || ''} ${lastName || ''}`.trim();

  return { getRecipientAvatars, getFullName };
}
